import {
  MultipleSelectionConfigurator
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const McmWebuiOptOutFeedbackSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'ESCWeb\\MultiChannelOptOut',
    style: {
      root: {
        minWidth: 600,
      },
    },
    others: {
      isUserInitiatedSurvey: true,
    },
    questions: [
      {
        Type: MultipleSelectionConfigurator,
        isRequired: true,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Why did you opt out of multi-channel management?')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('Advertiser policy don\'t allow Audience Spend')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('Poor Performance or Traffic Spike')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('Other Reason')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 2000,
          },
        ],
        data: {
        },
      },
    ],
  };
};
